import { render, staticRenderFns } from "./IE.vue?vue&type=template&id=2e97bd32&scoped=true&lang=html&"
import script from "./IE.vue?vue&type=script&lang=ts&"
export * from "./IE.vue?vue&type=script&lang=ts&"
import style0 from "./IE.vue?vue&type=style&index=0&id=2e97bd32&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e97bd32",
  null
  
)

export default component.exports